import {TypeError} from './../TypeDefinition'
import Scanner from './../Scanner'
import ProgramCode from './../ProgramCode'

import ParseExpression from './ParseExpression.js'

function ParseInspections (parser) {
    this.parser = parser
    this.SC = parser.config
    this.callbacks = parser.callbacks
    this.inspections = parser.inspections
}

ParseInspections.prototype = {
    parse (callableName) {
        if (this.inspections[callableName] === undefined) {
            return
        }

        let currentId
        let expType
        let isCurrentOk = true
        let oldScanner = this.parser.scanner
        let oldPcode = this.parser.pcode
        let oldError = this.parser.error

        function scannerError (text, line, column) {
            this.callbacks.inspectionError(callableName, currentId, 'Error al interpretar la expresión: no se reconoce el símbolo.')
            isCurrentOk = false
        }
        function error (token, message) {
            this.callbacks.inspectionError(callableName, currentId, new TypeError(), message)
            isCurrentOk = false
        }

        this.parser.error = error

        for (let id in this.inspections[callableName]) {
            currentId = id
            isCurrentOk = true

            let currentPcode = new ProgramCode()
            let currentScanner = Scanner(this.SC, this.parser.caseSensitive, scannerError)
            this.parser.pcode = currentPcode
            this.parser.scanner = currentScanner
            this.parser.scanner.analyze(this.inspections[callableName][id].expression)

            let parseExpression = new ParseExpression(this.parser, false)
            expType = parseExpression.parse()
            if (isCurrentOk) {
                this.callbacks.inspectionSuccess(callableName, id, expType)
                if (this.parser.compile) {
                    oldPcode.addInspection(callableName, id, this.inspections[callableName][id].expression, currentPcode)
                }
            }
        }
        this.parser.pcode = oldPcode
        this.parser.scanner = oldScanner
        this.parser.error = oldError
    }
}

export default ParseInspections



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseInspections.js